import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '@/core/http'
import {
  AuthConfigResponse,
  AuthResponse,
  CodeResponse,
  GoogleLoginBody,
  LoginBody,
  ResendBody,
  SignupBody,
  VerifyBody,
} from './auth.types'

// Our backend's customer auth (which proxies the BookSeats email-OTP flow and
// mints the app's bs_auth session cookie on verify). Two-step: login/signup
// return a `code` handle, verify exchanges code+otp for the session.
export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    login: builder.mutation<CodeResponse, LoginBody>({
      query: (data) => ({ url: '/auth/user/login', method: 'post', data }),
    }),
    signup: builder.mutation<CodeResponse, SignupBody>({
      query: (data) => ({ url: '/auth/user/signup', method: 'post', data }),
    }),
    verify: builder.mutation<AuthResponse, VerifyBody>({
      query: (data) => ({ url: '/auth/user/verify', method: 'post', data }),
    }),
    resend: builder.mutation<void, ResendBody>({
      query: (data) => ({ url: '/auth/user/resend', method: 'post', data }),
    }),
    googleLogin: builder.mutation<AuthResponse, GoogleLoginBody>({
      query: (data) => ({ url: '/auth/user/google', method: 'post', data }),
    }),
    // Public auth config (the Google OAuth client id, admin-set at runtime).
    authConfig: builder.query<AuthConfigResponse, void>({
      query: () => ({ url: '/auth/config', method: 'get' }),
    }),
  }),
})

export const {
  useLoginMutation,
  useSignupMutation,
  useVerifyMutation,
  useResendMutation,
  useGoogleLoginMutation,
  useLazyAuthConfigQuery,
} = authApi
